// extracted by mini-css-extract-plugin
module.exports = {"watchingNotice":"WatchCard_watchingNotice__3mW0b","noticeText":"WatchCard_noticeText__B17l-","watchingIcon":"WatchCard_watchingIcon__SGxT4","buttons":"WatchCard_buttons__1uPai"};